import { Stack, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { BaseLayout } from 'shared/components/baseLayout';

export function SoftwareConfig() {
    const { t } = useTranslation();
    return (
        <BaseLayout showNavBar={true}>
            <Stack align="center">
                <Title my="xl" order={3}>
                    {t('underconstruction')}
                </Title>
            </Stack>
        </BaseLayout>
    );
}
